// extracted by mini-css-extract-plugin
module.exports = {"page-site-map":"site-map_page-site-map__GjOQC","shop-info-box":"site-map_shop-info-box__ElwfO","content":"site-map_content__hSZqv"};